export default __webpack_public_path__ + "static/7-1973de510497823311fbee2a463bfe25.png";